export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const UPDATE_SETTINGS_CONFIG_GRAPH = 'UPDATE_SETTINGS_CONFIG_GRAPH';
export const UPDATE_SETTINGS_CONFIG_CRAWLER = 'UPDATE_SETTINGS_CONFIG_CRAWLER';